<template lang="pug">
  .edit-sub-address.narrow-modal-body
    SectionTitle(text="Edit Subscription Address").app-modal-title
    form(@submit="updateSubAddress")
      AddressSelectList

      .row.text-center
        hr
        AddNewAddressBtn(@new-address-click="addModalBackAction")

      .row
        SubmitButtons(
          submit-text="Save"
          :submit-method="updateSubAddress"
          :submit-disabled="savingSub"
          cancel-text="Cancel"
          :cancel-method="cancel"
        )

</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import SectionTitle from "../../../SectionTitle";
  import AddressSelectList from "../../../AddressBook/AddressSelectList";
  import AddNewAddressBtn from "../../../AddressBook/AddNewAddressBtn";
  import SubmitButtons from "../../../SubmitButtons";

  export default {
    name: "EditAutoDeliveryAddress",
    components: {
      SubmitButtons,
      AddNewAddressBtn,
      SectionTitle,
      AddressSelectList
    },

    computed: {
      ...mapState('subscriptions', [
        'savingSub',
        'subInEdit'
      ]),

      ...mapState('addressBook', [
        'selectedAddressId',
        'lastSavedAddress'
      ]),

      ...mapGetters('subscriptions', [
        'activeSubscriptions'
      ])
    },

    methods: {
      ...mapActions('subscriptions', [
        'updateSubscription',
        'updateSubsToUpdate'
      ]),

      ...mapActions('addressBook', [
        'clearSelectedAddress',
        'updateSubsModal',
        'updateLastSavedAddress'
      ]),

      ...mapActions('modal', ['hideModal']),

      addModalBackAction() {
        this.$store.commit('modal/pushModalStepBackAction', 'subscriptions/editAutoDeliveryAddressModal');
      },

      updateSubAddress() {
        var payload = {
          sub_id: this.subInEdit.id,
          changes: {
            shipping_address_id: this.selectedAddressId
          }
        };

        this.updateSubscription(payload).then(this.cleanUp);
      },

      cancel() {
        this.cleanUp();
      },

      cleanUp() {
        this.hideModal();
        this.clearSelectedAddress();
        //- when ever we save the sub we need to check if there is a new address and its set to default, if so
        //- prompt the user if they would like to update all their active subs with it (filter out sub just updated)
        if (this.lastSavedAddress.id && this.lastSavedAddress.is_default_shipping && this.activeSubscriptions.length) {
          //- filter current sub out of active subs

          let subsToUpdate = this.activeSubscriptions.filter(sub => sub.id != this.subInEdit.id);
          this.updateSubsToUpdate(subsToUpdate);
          this.updateSubsModal();
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .address-select-list
    padding 0.5em 0

  .new-address-btn
    padding-bottom 2em

</style>